'use client';

import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { Button } from '@/components/ui/button/button.component';
import { Typography } from '@/components/ui/typography/typography.component';
import { TypographyVariant } from '@/components/ui/typography/typography.type';

interface LaboratoryErrorFallbackProps {
  message: string;
  dataTestId?: string;
  onRetry(): void;
}

export function LaboratoryErrorFallback({
  message,
  dataTestId,
  onRetry,
}: LaboratoryErrorFallbackProps) {
  return (
    <div role="alert" data-testid={dataTestId} className="flex flex-col items-center gap-3 px-6 py-10">
      <Typography variant={TypographyVariant.BODY_TEXT} className="text-center text-gray-500">
        {message}
      </Typography>

      <Button
        variant="secondary"
        data-testid={DataTestIdEnum.BRANCH_LABORATORY_ERROR_RETRY}
        onClick={onRetry}
      >
        Tentar novamente
      </Button>
    </div>
  );
}
